import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import WarningIcon from "@mui/icons-material/Warning";
import CustomSubCardData from "./CustomSubCardData";

import GridContainer from "components/CustomGrid/GridContainer.js";
import GridItem from "components/CustomGrid/GridItem.js";
import { getProfilePicture } from "../../services/ConfigServices";

const Card = styled.div`
  border: 0 rgba(255, 0, 0, 0.1);
  margin-bottom: 0;
  margin-top: 0.5rem;
  color: #ffffff;
  background: #605F70;
  width: 100%;
  box-shadow: 0 1px 4px 0 grey;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: "break-word";
  font-size: 14px;
  border-radius: 6px;
  font-family: "Source Sans Pro",sans-serif;
`;

const Container = styled.div`
  border: 0;
  display: flex;

  flex-direction: column;
  margin-bottom: 0;
  margin-top: 0px;
  color: #ffffff;
  background: #605F70;
  width: 100%;
  position: relative;
  min-width: 0;
  word-wrap: break-word;
  font-size: 14px;
  font-family: "Source Sans Pro",sans-serif;
`;
const CardTitle = styled.h3`

  margin-top: 0.7rem;
  font-size: 1.1rem;
  font-weight: 500;
  font-family: "Source Sans Pro",sans-serif;
`;

const CardSubTitle = styled.h3`
  margin-top: 0.7rem;
  font-size: 1.1rem;
  font-weight: 500;
  font-family: "Source Sans Pro",sans-serif;
  font-style: italic;
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0rem 0.9rem 0rem 0.9rem;
  font-family: "Source Sans Pro",sans-serif;
`;

const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
  flex-wrap: wrap;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;

const Separator = styled.div`
border-bottom: 2px solid #a8a8a8;
height: 2px;
margin-bottom: 0.6rem;
margin-left: 0.8rem;
margin-right: 0.8rem;
`;

const NoPhoto = styled.div`
background-color: #9798a0;
    height: 150px;
    padding-top: 60px;
    text-align: center;
`;

const infoWindowImg = {
  height: 'auto',
  maxWidth: '98%',
  marginLeft: '1%',
  verticalAlign: 'middle',
  marginBottom: '10px'
}

const markerInfoCardBody = {
  paddingRight: '1rem',
  paddingLeft: '1rem',
  paddingBottom: '1rem',
}

const pStyle = {
  fontSize: ' 0.875rem',
  lineHeight: ' 1.5',
  marginBottom: '1.25rem',
  fontWeight: '400'
}

const infoWindowCarousel = {
  height: 'auto',
  maxWidth: '100%',
  verticalAlign: 'middle',
  marginTop: "-1rem",
  padding: "1rem",
  backgroundColor: '#605F70',
  color: '#ffffff',
  fontSize: '16px',
  fontWeight: 600
}

const iconStyle = { color: "#297373", fontSize: 50, marginTop: "-0.2rem" };

const getType = (type, subtype) => {
  let typeStr = "";
  if (type == 0) {
    if (subtype == 0)
      typeStr = "Commune";
    else if (subtype == 1)
      typeStr = "EPCI";
    else if (subtype == 1)
      typeStr = "Groupe";
  }
  else if (type == 1)
    typeStr = "Site";
  else if (type == 2) {
    if (subtype == 0)
      typeStr = "Bâtiment";
    else if (subtype == 1)
      typeStr = "Equipement urbain";
  }
  else if (type == 3)
    typeStr = "Zone";
  else if (type == 4)
    typeStr = "Compte client";
  return typeStr;
};

function CustomCardMBM(props) {

  return (
    <div>
      {props.siteinfo ?
        (
          <Card>
            <TitleContainer>
              <CardTitle>{props.siteinfo?.name}</CardTitle>
              <CardSubTitle>{getType(props.siteinfo?.type, props.siteinfo?.subtype)}</CardSubTitle>
            </TitleContainer>
            <Container>

              <div className={"info-window-img"}>
                {props.siteinfo?.picture ? (
                  <img
                    data-src="holder.js/100px180/"
                    style={infoWindowImg}
                    src={getProfilePicture(props.siteinfo?.picture)}
                    data-holder-rendered="true"
                    alt={""}
                  />
                ) :
                  (<NoPhoto>
                    Aucune photo enregistrée
                  </NoPhoto>
                  )

                }
              </div>
              <DataList>
                {
                  (props.siteinfo?.type != 3) ?
                    <DataContainer>
                      <Data>{"Adresse :"}</Data>
                      <DataResult>{props.siteinfo?.address}</DataResult>
                    </DataContainer> : <></>
              }

                {
                  (props.siteinfo?.type == 4 || props.siteinfo?.type == 0 || props.siteinfo?.type == 1)  ?
                    <DataContainer>
                      <Data>{"Nombre de bâtiments :"}</Data>
                      <DataResult>{props.siteinfo?.countbat}</DataResult>
                    </DataContainer> : <></>
                }
                <DataContainer>
                  <Data>{"Surface totale :"}</Data>
                  <DataResult>{props.siteinfo?.surface?  props.siteinfo?.surface + " m²" : 'N/A'}</DataResult>
                </DataContainer>
              </DataList>
              <Separator />
              <DataList>
                <DataContainer>
                  <Data>{"Etat de connexion des systèmes :"}</Data>
                  <DataResult>{props.siteinfo?.eqpercent + '%'}</DataResult>
                </DataContainer>
              </DataList>
              <Separator />
              <DataList>
                <DataContainer>
                  <Data>{"Performance de l'éclairage :"}</Data>
                  <DataResult>{props.siteinfo?.alertsecl > 0 ? props.siteinfo?.alertsecl + ' alerte(s)' : 'OK'}</DataResult>
                </DataContainer>
                <DataContainer>
                  <Data>{"Performance du chauffage :"}</Data>
                  <DataResult>{props.siteinfo?.alertsecl > 0 ? props.siteinfo?.alertschauf + ' alerte(s)' : 'OK'}</DataResult>
                </DataContainer>
              </DataList>
            </Container>
          </Card>
        ) : (<div></div>)}
    </div>
  );
}

CustomCardMBM.propTypes = {
  siteinfo: PropTypes.object,
};

export default CustomCardMBM;
